// Action Types
export const SHOW_UNASSIGN_MODAL = 'SHOW_UNASSIGN_MODAL';
export const HIDE_UNASSIGN_MODAL = 'HIDE_UNASSIGN_MODAL';



// WEBPACK FOOTER //
// ./components/unassign-all-modal/store/unassign-all-modal.actions.js